export const PageNotFound = () => {
    return (
        <div>
            This page doesn't exist!
        </div>
    )
}